module.exports = __webpack_public_path__ + "media/images/icons/outlined/fullscreen-exit-9209eafe3b2fc908486237524e5ebd51.svg";